
import React from 'react';
import './cage-search.css'

const SizeAndTypeList = ({cageData}) => {
    console.log("HERe", cageData)
    const rowNames = ['Business Size', 'Type of Business', 'Woman Owned?'];

    let rowValues = ['N/A', 'N/A', 'N/A'];

    if (cageData.length) {
        rowValues = [cageData[0]?.bus_size || 'N/A', cageData[0]?.type_of_business || 'N/A', cageData[0]?.woman_owned || 'N/A'];
    }

    return (
        <div className='size-list-container'>
            <div className='size-list-column'>
                {
                    rowNames.map((name, i) => {
                        return <div key={'row-name-' + i} className='size-list-item'>{name}</div>
                    })
                }
            </div>
            <div className='size-list-column'>
                {
                    rowValues.map((value, i) => {
                        return <div key={'row-value-' + i} className='size-list-item'>{value}</div>
                    })
                }
            </div>
        </div>
    );
}

export default SizeAndTypeList